"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoteEvent = exports.RepayEvent = exports.ProposalUpdateEvent = exports.ProposalCreateEvent = exports.MintEvent = exports.LiquidateEvent = exports.EscrowUnlockEvent = exports.EscrowLockEvent = exports.ClaimEvent = exports.BurnEvent = exports.ProtocolEvent = void 0;
var tslib_1 = require("tslib");
var yieldblox_base_1 = require("yieldblox-base");
var ProtocolEvent = (function () {
    function ProtocolEvent(userPublicKey, type, timestamp, fee) {
        this.userPublicKey = userPublicKey;
        this.type = type;
        this.timestamp = timestamp;
        this.fee = fee;
    }
    return ProtocolEvent;
}());
exports.ProtocolEvent = ProtocolEvent;
var BurnEvent = (function (_super) {
    (0, tslib_1.__extends)(BurnEvent, _super);
    function BurnEvent(userPublicKey, targetPool, withdrawal, burn) {
        var _this = _super.call(this, userPublicKey, yieldblox_base_1.ProtocolEventTypes.TX_BURN, Date.now(), "10000") || this;
        _this.targetPool = targetPool;
        _this.withdrawal = withdrawal;
        _this.burn = burn;
        return _this;
    }
    return BurnEvent;
}(ProtocolEvent));
exports.BurnEvent = BurnEvent;
var ClaimEvent = (function (_super) {
    (0, tslib_1.__extends)(ClaimEvent, _super);
    function ClaimEvent(userPublicKey, targetPool, operation) {
        var _this = _super.call(this, userPublicKey, yieldblox_base_1.ProtocolEventTypes.TX_CLAIM, Date.now(), "10000") || this;
        _this.targetPool = targetPool;
        _this.operation = operation;
        return _this;
    }
    return ClaimEvent;
}(ProtocolEvent));
exports.ClaimEvent = ClaimEvent;
var EscrowLockEvent = (function (_super) {
    (0, tslib_1.__extends)(EscrowLockEvent, _super);
    function EscrowLockEvent(userPublicKey, escrowAmount, isCollateral, period) {
        var _this = _super.call(this, userPublicKey, yieldblox_base_1.ProtocolEventTypes.TX_ESCROW, Date.now(), "10000") || this;
        _this.escrowAmount = escrowAmount;
        _this.isCollateral = isCollateral;
        _this.period = period;
        return _this;
    }
    return EscrowLockEvent;
}(ProtocolEvent));
exports.EscrowLockEvent = EscrowLockEvent;
var EscrowUnlockEvent = (function (_super) {
    (0, tslib_1.__extends)(EscrowUnlockEvent, _super);
    function EscrowUnlockEvent(userPublicKey, unlockEarlyEscrows, unlockEscrows) {
        var _this = _super.call(this, userPublicKey, yieldblox_base_1.ProtocolEventTypes.TX_ESCROW, Date.now(), "10000") || this;
        _this.unlockEarlyEscrows = unlockEarlyEscrows;
        _this.unlockEscrows = unlockEscrows;
        return _this;
    }
    return EscrowUnlockEvent;
}(ProtocolEvent));
exports.EscrowUnlockEvent = EscrowUnlockEvent;
var LiquidateEvent = (function (_super) {
    (0, tslib_1.__extends)(LiquidateEvent, _super);
    function LiquidateEvent(userPublicKey, liquidateeId, repayments, withdrawals, targetPool, backstopOrder, collateralRepayments) {
        var _this = _super.call(this, userPublicKey, yieldblox_base_1.ProtocolEventTypes.TX_LIQUIDATE, Date.now(), "10000") || this;
        _this.liquidateeId = liquidateeId;
        _this.repayments = repayments;
        _this.withdrawals = withdrawals;
        _this.targetPool = targetPool;
        _this.backstopOrder = backstopOrder;
        _this.collateralRepayments = collateralRepayments;
        return _this;
    }
    return LiquidateEvent;
}(ProtocolEvent));
exports.LiquidateEvent = LiquidateEvent;
var MintEvent = (function (_super) {
    (0, tslib_1.__extends)(MintEvent, _super);
    function MintEvent(userPublicKey, targetPool, collateralizations, deposit, borrow) {
        var _this = _super.call(this, userPublicKey, yieldblox_base_1.ProtocolEventTypes.TX_MINT, Date.now(), "10000") || this;
        _this.targetPool = targetPool;
        _this.collateralizations = collateralizations;
        _this.deposit = deposit;
        _this.borrow = borrow;
        return _this;
    }
    return MintEvent;
}(ProtocolEvent));
exports.MintEvent = MintEvent;
var ProposalCreateEvent = (function (_super) {
    (0, tslib_1.__extends)(ProposalCreateEvent, _super);
    function ProposalCreateEvent(userPublicKey, proposalAccountId, proposalType, params) {
        var _this = _super.call(this, userPublicKey, yieldblox_base_1.ProtocolEventTypes.TX_PROPOSAL_CREATE, Date.now(), "10000") || this;
        _this.proposalAccountId = proposalAccountId;
        _this.proposalType = proposalType;
        _this.params = params;
        return _this;
    }
    return ProposalCreateEvent;
}(ProtocolEvent));
exports.ProposalCreateEvent = ProposalCreateEvent;
var ProposalUpdateEvent = (function (_super) {
    (0, tslib_1.__extends)(ProposalUpdateEvent, _super);
    function ProposalUpdateEvent(userPublicKey, proposalAccountId, proposalType) {
        var _this = _super.call(this, userPublicKey, yieldblox_base_1.ProtocolEventTypes.TX_PROPOSAL_UPDATE, Date.now(), "10000") || this;
        _this.proposalAccountId = proposalAccountId;
        _this.proposalType = proposalType;
        return _this;
    }
    return ProposalUpdateEvent;
}(ProtocolEvent));
exports.ProposalUpdateEvent = ProposalUpdateEvent;
var RepayEvent = (function (_super) {
    (0, tslib_1.__extends)(RepayEvent, _super);
    function RepayEvent(userPublicKey, repayment, targetPool, collateralRepayments) {
        var _this = _super.call(this, userPublicKey, yieldblox_base_1.ProtocolEventTypes.TX_REPAY, Date.now(), "10000") || this;
        _this.repayment = repayment;
        _this.targetPool = targetPool;
        _this.collateralRepayments = collateralRepayments;
        return _this;
    }
    return RepayEvent;
}(ProtocolEvent));
exports.RepayEvent = RepayEvent;
var VoteEvent = (function (_super) {
    (0, tslib_1.__extends)(VoteEvent, _super);
    function VoteEvent(userPublicKey, proposalAccountId, votes, proposalType) {
        var _this = _super.call(this, userPublicKey, yieldblox_base_1.ProtocolEventTypes.TX_VOTE, Date.now(), "10000") || this;
        _this.proposalAccountId = proposalAccountId;
        _this.votes = votes;
        _this.proposalType = proposalType;
        return _this;
    }
    return VoteEvent;
}(ProtocolEvent));
exports.VoteEvent = VoteEvent;
//# sourceMappingURL=index.js.map